(() => {
    const group = document.querySelector(".tab-group");
    if (!group) return;

    const buttons = group.querySelectorAll("a");
    buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {

        const isAnchor = btn.hasAttribute('data-anchor') && btn.getAttribute('href').startsWith('#');
        //if (isAnchor) e.preventDefault();

        buttons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        if (isAnchor) {
          const target = document.querySelector(btn.getAttribute('href'));
          if (!target) return;

          const panes = document.querySelectorAll(".sc-tab-pane");

          panes.forEach(p => p.classList.remove("active"));
          target.classList.add("active");
        }
      });
    });
})();